import React, { useState, useEffect } from 'react';

const TestProgress = () => {
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('Initializing test...');

  useEffect(() => {
    const messages = [
      'Initializing test...',
      'Connecting to server...',
      'Starting load test...',
      'Sending requests...',
      'Analyzing responses...',
      'Almost done...',
    ];

    let currentStep = 0;
    const interval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev + 2;
        if (newProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return newProgress;
      });

      if (currentStep < messages.length - 1 && progress > (currentStep + 1) * 16) {
        currentStep++;
        setMessage(messages[currentStep]);
      }
    }, 300);

    return () => clearInterval(interval);
  }, [progress]);

  return (
    <div className="fade-in" style={styles.container}>
      <div className="card" style={styles.card}>
        <div style={styles.iconContainer}>
          <div style={styles.loadingIcon}>⚡</div>
        </div>

        <h2 style={styles.title}>Running Load Test</h2>
        <p style={styles.message}>{message}</p>

        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <p style={styles.progressText}>{progress}%</p>

        <div style={styles.info}>
          <p style={styles.infoText}>
            This may take a few moments. Please don't close this page.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 200px)',
  },
  card: {
    maxWidth: '500px',
    textAlign: 'center',
  },
  iconContainer: {
    marginBottom: '20px',
  },
  loadingIcon: {
    fontSize: '64px',
    animation: 'pulse 2s ease-in-out infinite',
  },
  title: {
    fontFamily: "'Agrandir Narrow', 'Agrandir', Arial, sans-serif",
    fontSize: '32px',
    fontWeight: '700',
    fontStyle: 'normal',
    marginBottom: '10px',
    color: 'var(--text-primary)',
  },
  message: {
    fontSize: '16px',
    color: 'var(--text-secondary)',
    marginBottom: '30px',
  },
  progressText: {
    fontSize: '24px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginTop: '20px',
  },
  info: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid var(--border-color)',
  },
  infoText: {
    fontSize: '14px',
    color: 'var(--text-secondary)',
  },
};

export default TestProgress;

